<template>
  <div class="activity-duration">
    <div v-for="field in fields" :key="field.key" class="row">
      <div class="activity-duration__section col-12 col-md-3">
        <FormulateInput
          :key="`duration-${field.key}`"
          :ref="`duration-${field.key}-ref`"
          v-model="formValues[field.key]"
          class="__duration-input"
          :label="field.radioBtn.label"
          ignored
          type="time-duration"
          placeholder="00 Jam 00 Menit"
          tooltip="Rata-rata durasi aktivitas ambil atau kirim pada setiap Alamat DO"
          :initialValues="initDurationValues"
          :disabled="field.key === 'all' ? isSelectMergeBtnDisabled : !isSelectMergeBtnDisabled"
          :optionItems="optionItems"
          validation="isoTimeGteValue:PT3M"
          validation-behavior="live"
          error-behavior="live"
          @input="() => handleDurationInput({ key: field.key })"
        >
          <template #prefix>
            <div class="formulate-input-prefix">
              <span>{{ '+' }}</span>
            </div>
          </template>
        </FormulateInput>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    squashDuration: {
      type: Number,
      default: 2,
    },
    serviceTime: {
      type: String,
      default: 'PT15M',
    },
  },
  emits: ['update:squashDuration'],
  data() {
    return {
      isHover: false,
      isSelectMerge: true,

      formValues: {
        all: 'PT15M',
        eachDO: 'PT15M',
      },
      initDurationValues: {
        hours: 0,
        minutes: 15,
      },

      optionItems: [
        {
          key: 'hours',
          items: Array.from({ length: 24 }, (_, i) => i),
        },
        {
          key: 'minutes',
          items: Array.from({ length: 60 }, (_, i) => i),
        },
      ],
      fields: [
        {
          key: 'all',
          radioBtn: {
            id: 'all',
            label: 'Durasi Aktivitas per Alamat',
            initialValue: true,
          },
          durationInput: {
            key: 'all',
          },
        },
      ],
    }
  },
  computed: {
    isSelectMergeBtnDisabled() {
      return this.isSelectMerge ? false : true
    },
  },
  watch: {
    squashDuration(newValue) {
      if (newValue === 2) {
        this.isSelectMerge = true
        return
      }

      this.isSelectMerge = false
    },
  },
  methods: {
    ResetFormValues() {
      this.formValues = {
        all: 'PT15M',
        eachDO: 'PT15M',
      }
    },

    handleInput({ key }) {
      // Clear validation errors once at the start
      const refs = ['all', 'eachDO']
      refs.forEach((ref) => {
        this.$refs[`duration-${ref}-ref`][0].validationErrors = []
      })

      this.handleDurationInput({ key })

      // Set validation and state based on key
      const isAllKey = key === 'all'
      this.$refs[`duration-${key}-ref`][0].performValidation()
      this.isSelectMerge = isAllKey

      // Emit updated squash duration
      this.$emit('update:squashDuration', isAllKey ? 2 : null)
    },

    handleDurationInput({ key }) {
      this.$emit('update:serviceTime', this.formValues[key])
    },
  },
}
</script>

<style lang="scss" scoped>
.activity-duration {
  &__title {
    font-size: 13px;
    display: flex;
    gap: 4px;
    align-items: center;

    p {
      margin: 0;
    }
  }

  &__section {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-left: -4px;

    .__duration-input {
      width: 300px;
    }
  }
}
</style>